import React from 'react'
import Reveal from './Reveal'

interface Item {
    title: string
    text: string
}

function ValueGrid({ items, inverted }: { items: Item[], inverted?: boolean }) {
    return (
        <div className={`ibg-values ${inverted ? 'is-inverted' : ''}`}>
            {items.map((item, index) => (
                <Reveal key={item.title} delay={index * 0.06} className="ibg-value">
                    <span className="ibg-value__index">{String(index + 1).padStart(2, '0')}</span>
                    <h3 className="ibg-h4">{item.title}</h3>
                    <p className="ibg-small">{item.text}</p>
                </Reveal>
            ))}
        </div>
    )
}

export default ValueGrid
